import { Icon } from '~/components/atomic';
import { useUserStore } from '~/store';
import * as S from './UserInfo.styled';

interface UserInfoProps {
  isOpen: boolean;
  setIsOpen: (isBottomSheetOpen: boolean) => void;
}

export default function UserInfo({ isOpen, setIsOpen }: UserInfoProps) {
  const { name, nickName } = useUserStore((state) => ({
    name: state.name,
    nickName: state.nickname,
  }));

  const handleEditName = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <S.Container>
        <S.NameWrapper>
          <S.NameBox>
            <S.Name>Hi, {nickName}</S.Name>
            <S.EditButtonBox>
              <S.EditButton onClick={handleEditName}>
                <Icon color={'hierarchy1'} size={28} iconName='Edit' />
              </S.EditButton>
            </S.EditButtonBox>
          </S.NameBox>
          <S.NickNameBox>
            <S.NickName>{name}</S.NickName>
          </S.NickNameBox>
        </S.NameWrapper>
      </S.Container>
    </>
  );
}
